webpackJsonp([278158968741676],{

/***/ 549:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAABTCAIAAACebPnyAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAG5JREFUeNrs1UkKgEAMBdHOv/+dI25cZyBBtN5aKbpN8BwAAAAA+B93L7+rhYwWTqOFS9PCt8k1zKyQSZ+jkKncVTaj2jimMmqu5BObmqtIoLUfwcD9ZG0n4oHuXI3vx/iev+7/AQAAAABfcgkwACPVKhU4ycDfAAAAAElFTkSuQmCC"

/***/ }),

/***/ 550:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAABTCAIAAACebPnyAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAH1JREFUeNrs1jEOgCAMAEAb/v9mHFwIOhiEBpPrxHa0hUI51kdhMBgMBoPBYDAYjCRjPGqty4H3RnzJICKWGO32lxhdfeYbbYmu9WSj68F8497kycbjKfphHkn9SDpXSfcj6Z6PzauMubvx++HPwGAwGAwGg8FgMLY0TgEGANntTr/N7CwJAAAAAElFTkSuQmCC"

/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyImage = __webpack_require__(13);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _orange_symbol = __webpack_require__(48);
	
	var _orange_symbol2 = _interopRequireDefault(_orange_symbol);
	
	var _gatsbyLink = __webpack_require__(16);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _nextProject = __webpack_require__(549);
	
	var _nextProject2 = _interopRequireDefault(_nextProject);
	
	var _previousProject = __webpack_require__(550);
	
	var _previousProject2 = _interopRequireDefault(_previousProject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MBPostTemplate = function MBPostTemplate(_ref) {
	  var data = _ref.data,
	      pathContext = _ref.pathContext;
	
	  var acf = data.wordpressWpMbProject.acf;
	  var prev = pathContext.prev,
	      next = pathContext.next;
	
	  console.log(acf);
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: "Project '" + acf.project_title + "' | Moon Beyond Co" }),
	    _react2.default.createElement(
	      "div",
	      { className: "next-previous-project xs-display-none" },
	      _react2.default.createElement(
	        "div",
	        { className: "next-project" },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/projects/" + next.slug },
	          _react2.default.createElement("img", {
	            src: _nextProject2.default,
	            className: "next-project-img",
	            alt: "Next Project"
	          }),
	          _react2.default.createElement(
	            "span",
	            null,
	            "Next Project"
	          ),
	          _react2.default.createElement("img", {
	            src: next.acf.thumbnail.localFile.childImageSharp.resolutions.src,
	            className: "attachment-medium size-medium wp-post-image"
	          })
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "previous-project" },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/projects/" + prev.slug },
	          _react2.default.createElement("img", {
	            width: 300,
	            height: 187,
	            src: prev.acf.thumbnail.localFile.childImageSharp.resolutions.src,
	            className: "attachment-medium size-medium wp-post-image",
	            sizes: "(max-width: 300px) 100vw, 300px"
	          }),
	          _react2.default.createElement("img", {
	            src: _previousProject2.default,
	            className: "previous-project-img",
	            alt: "Previous Project"
	          }),
	          _react2.default.createElement(
	            "span",
	            null,
	            "Previous Project"
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "section",
	      { className: "project-img" },
	      _react2.default.createElement(_gatsbyImage2.default, {
	        sizes: acf.header_image.localFile.childImageSharp.sizes,
	        className: "wow fadeIn"
	      })
	    ),
	    _react2.default.createElement(
	      "section",
	      { className: "no-padding" },
	      _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	          "div",
	          { className: "row project-content" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-7 col-sm-10 center-col text-center text-med" },
	            _react2.default.createElement(
	              "h6",
	              { className: "wow fadeIn animated" },
	              _react2.default.createElement(
	                "strong",
	                { className: "black-text" },
	                acf.project_title
	              )
	            ),
	            _react2.default.createElement("p", {
	              className: "wow fadeIn",
	              dangerouslySetInnerHTML: { __html: acf.project_categories }
	            })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "no-padding-top" },
	      _react2.default.createElement(
	        "div",
	        { className: "project-img" },
	        acf.project_images.filter(function (a) {
	          return a.localFile;
	        }).map(function (a, i) {
	          return _react2.default.createElement(_gatsbyImage2.default, {
	            sizes: a.localFile.childImageSharp.sizes,
	            className: "wow fadeIn",
	            key: i
	          });
	        })
	      )
	    ),
	    _react2.default.createElement(
	      "section",
	      { className: "description" },
	      _react2.default.createElement(
	        "div",
	        { className: "container projectsContainer" },
	        _react2.default.createElement(
	          "div",
	          { className: "row wow fadeIn animated" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-xs-8 col-sm-2 sidebarTitle hidden-xs " },
	            _react2.default.createElement(
	              "h2",
	              null,
	              _react2.default.createElement("img", {
	                src: _orange_symbol2.default,
	                className: "headingDescription-titleSymbol",
	                alt: true
	              }),
	              "Case Study"
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "Launched: ",
	              acf.launch_year,
	              _react2.default.createElement("br", null),
	              "Project MB-",
	              acf.project_number
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-xs-4 col-sm-1 sidebarElementColumn hidden-xs" },
	            _react2.default.createElement("div", { className: "diagonalLine" })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-sm-8 projectInfo" },
	            _react2.default.createElement(
	              "h2",
	              null,
	              acf.project_title
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              acf.project_info_line_1,
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "i",
	                null,
	                acf.project_info_line_2
	              ),
	              _react2.default.createElement("br", null),
	              acf.project_info_line_3
	            ),
	            _react2.default.createElement(
	              "h3",
	              null,
	              "Project Description"
	            ),
	            _react2.default.createElement("p", {
	              dangerouslySetInnerHTML: { __html: acf.project_description }
	            }),
	            _react2.default.createElement("div", { className: "projectInfo__divider" }),
	            _react2.default.createElement(
	              "p",
	              { className: "waterMark" },
	              "Designed by Moon Beyond Creative"
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = MBPostTemplate;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-m-bpost-js-3e9a4bf5b4a9419b0737.js